import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  getRouteName,
  NOT_ALLOWED_BACK_ROUTES,
  ROUTES_MAP,
} from 'app/shared/utils/routes';

// Selectors
import { selectRoutingHistory } from 'app/modules/navigator/selectors';
import {
  U21Button,
  U21Spacer,
  U21Typography,
} from 'app/shared/u21-ui/components';
import styled from 'styled-components';

export const FourOhFour = () => {
  const routingHistory = useSelector(selectRoutingHistory);

  const route = useMemo(() => {
    const validRoute = {
      path: '',
      name: '',
    };

    for (const i of routingHistory) {
      const routeName = getRouteName(i.route);
      if (!NOT_ALLOWED_BACK_ROUTES[i.route] && routeName) {
        validRoute.path = i.route;
        validRoute.name = routeName;
        break;
      }
    }

    return validRoute;
  }, [routingHistory]);

  return (
    <StyledU21Spacer>
      <Header>
        <U21Typography variant="h1">404</U21Typography>
        <U21Typography variant="h4">Page not found</U21Typography>
      </Header>
      {route.path ? (
        <U21Button color="primary" to={route.path} variant="text">
          Go back to {route.name}
        </U21Button>
      ) : (
        <U21Button color="primary" to={ROUTES_MAP.home.path} variant="text">
          Take me home
        </U21Button>
      )}
    </StyledU21Spacer>
  );
};

const StyledU21Spacer = styled(U21Spacer)`
  margin-top: 100px;
  align-items: center;
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
